
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Trophy, Award, Users, Zap } from 'lucide-react';

interface InitiationCompleteProps {
  userData: any;
  onFinish: () => void;
}

const InitiationComplete = ({ userData, onFinish }: InitiationCompleteProps) => {
  if (!userData) {
    return (
      <div className="text-center py-8">
        <p className="text-tan-dark">Loading completion data...</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-center">
        <Trophy className="mx-auto mb-4 text-yellow-400" size={64} />
        <h3 className="text-2xl font-bold text-tan mb-2">Initiation Complete!</h3>
        <p className="text-tan-dark">
          Welcome to the BroMentum brotherhood! You're now officially part of the swarm.
        </p>
      </div>

      <Card className="bg-navy-dark border-tan">
        <CardContent className="p-6 text-center">
          <h4 className="text-xl font-bold text-tan mb-4">Your BroCode</h4>
          <div className="bg-tan text-navy p-4 rounded-lg font-mono text-xl font-bold mb-4">
            {userData.brocode}
          </div>
          <div className="flex items-center justify-center gap-2 mb-2">
            <Award className="text-tan" size={20} />
            <span className="text-tan font-medium">Rank: {userData.rank}</span>
          </div>
          <div className="flex items-center justify-center gap-2">
            <Zap className="text-yellow-400" size={20} />
            <span className="text-tan-dark">Total BroScore: {userData.bro_score}</span>
          </div>
        </CardContent>
      </Card>

      <div className="space-y-3">
        <h4 className="text-tan font-medium">You now have access to:</h4>
        <div className="space-y-2">
          <div className="flex items-center gap-3 text-tan-dark">
            <Users size={16} className="text-tan" />
            <span>Community features and discussions</span>
          </div>
          <div className="flex items-center gap-3 text-tan-dark">
            <Trophy size={16} className="text-tan" />
            <span>Games, wagers, and competitions</span>
          </div>
          <div className="flex items-center gap-3 text-tan-dark">
            <Zap size={16} className="text-tan" />
            <span>Daily roulette and reward system</span>
          </div>
          <div className="flex items-center gap-3 text-tan-dark">
            <Award size={16} className="text-tan" />
            <span>Engagement missions and bonuses</span>
          </div>
        </div>
      </div>

      <Button 
        onClick={() => {
          // Store BroCode in localStorage for authentication
          if (userData.brocode) {
            localStorage.setItem('brocode', userData.brocode);
            localStorage.setItem('user_brocode', userData.brocode);
            console.log(`✅ [STORAGE] BroCode stored: ${userData.brocode}`);
          }
          
          // Navigate to dashboard view
          window.location.hash = '#dashboard';
          onFinish();
        }}
        className="w-full bg-tan text-navy hover:bg-tan-dark"
      >
        Enter BroMentum Dashboard
      </Button>
    </div>
  );
};

export default InitiationComplete;
